import { NavigateFunction } from "react-router-dom";
import { ROUTE_PATHS } from "../../../routes/paths";
import { ResetPasswordFormData } from "./config";

export function handleResetPasswordSuccess(navigate: NavigateFunction): void {
  navigate(ROUTE_PATHS.AUTH.LOGIN);
}

export function getResetPasswordPayload(
  data: ResetPasswordFormData
): { password: string } {
  return {
    password: data.password,
  };
}

export function validateToken(token: string | null): boolean {
  return Boolean(token);
}

export const TOKEN_ERROR_MESSAGE =
  "Invalid or missing token. Please request a new password reset link.";
